<template>
  <PriceAssessmentsTab
    :product="product"
    :show-latest-report-section-in-price-assessments="
      showLatestReportSectionInPriceAssessments
    "
  />
</template>

<script lang="ts" setup>
import PriceAssessmentsTab from '~/components/reports/PriceAssessmentsTab.vue'
import type { TProduct } from '~/src/types/product'
/*-------------------------------------
  Meta
-------------------------------------*/
definePageMeta({ isTab: true })

/*-------------------------------------
  Props & Refs
-------------------------------------*/
defineProps<{
  product: TProduct
  showLatestReportSectionInPriceAssessments?: boolean
}>()
</script>
